//Importacion de estados
import { useEffect, useState } from 'react';

//Importacion de estilos
import './styles/App.css';
import './styles/casillas.css';
import './styles/fichos.css';

//Importacion de componentes
import Casilla from './components/Casilla';
import Dado from './components/Dado';
import BotonIniciarJuego from './components/BotonIniciarJuego';
import Countdown from './components/CuentaRegresiva';
import CajonPreguntas from './components/CajonPreguntas/CajonPreguntas';
import Respuesta from './components/CajonPreguntas/Respuesta';
import Alertas from './components/Alertas';
import PantallaFinal from './components/PantallaFinal';
import PantallaInicio from './components/PantallaInicio';
import Pistas from './components/CajonPistas.js/Pistas';
import PanelDePuntuaciones from './components/PanelDePuntuaciones';
import LogoAnimado from './components/LogoAnimado';
import LogosUDEA from './components/LogosUDEA';
import LogoGobierno from './components/LogoGobierno';
import Instrucciones from './components/Instrucciones';
import Alertas2 from './components/Alertas2';

//Importacion de librerias
import { DragDropContext } from "react-beautiful-dnd";

//Importacion de funciones
import { casillas } from './Lib/listaCasillas';
import { puntuaciones, puntuaciones2, puntuaciones3, puntuaciones4, puntuaciones5, puntuaciones6 } from './Lib/puntuaciones';
import { reorder, validarTurno, letreroTurno, validarLlegada, saltarNotificacionesCasilasEscalera, casillaDestinoEscalera, casillaDestinoTobogan, saltarNotificacionesCasilasTobogan } from './Lib/funcionDragAndDrop';
import { manejoAlertas, establecerPosicionFichos, manejoAlertasPerderTurno, asignacionPuntos, corroborarCasillaPregunta, turnoExtra, pantallaInicioFuncionamiento, asignacionPreguntasAcumulacion, validarCasillasPista, cambioTurnoControlEstados } from './Lib/funciones';
import Formulario from './components/Formulario/Formulario';
import PartidaFinalizada from './components/PartidaFinalizada';
import EscaleraInteractiva from './components/EscaleraInteractiva';

//Importacion de imagenes
import asset1 from './imgs/otros/juego rio 2-24.png';
import asset2 from './imgs/otros/juego rio 2-30.png';
import asset3 from './imgs/otros/juego rio 2-23.png';
import asset4 from './imgs/otros/juego rio 2-29.png';
import asset5 from './imgs/otros/juego rio 2-25.png';
import asset6 from './imgs/otros/juego rio 2-21.png';
import asset7 from './imgs/otros/juego rio 2-26.png';
import asset8 from './imgs/otros/juego rio 2-28.png';
import asset9 from './imgs/otros/juego rio 2-31.png';
import AlertaDeCasillaUno from './components/AlertaDeCasillaUno';







let puntuacionesRespaldo = puntuaciones;
let puntuacionesRespaldo2 = puntuaciones2;
let puntuacionesRespaldo3 = puntuaciones3;
let puntuacionesRespaldo4 = puntuaciones4;
let puntuacionesRespaldo5 = puntuaciones5;
let puntuacionesRespaldo6 = puntuaciones6;

let reinicios = 0;

function App() {
  const [ casillasEstado, setCasillasEstado ] = useState(casillas);

  //Creamos un estado que almacene las puntuaciones de los jugadores.
  const [ puntuacion, setPuntuacion ] = useState(puntuacionesRespaldo);





  //Creamos el estado que se encargara de almacenar los diferentes valores del dado.
  const [ valorDado, setValorDado ] = useState(150);

  //Creamos un estado que nos indique cuando se tire el dado en el turno actual esto para validar el final del juego cuando el usuario debe sacar el numero exacto para llegar a la meta
  const [ tiradaDado, setTiradaDado ] = useState(false);

  //Creamos un estado que guardara los turnos de cada ficho.
  const [turnoActual, setTurnoActual] = useState(1);

  //Creamos un estado que maneje el comportamiento de el boton de iniciar el juego.
  const [ estadoIniciarJuego, setEstadoIniciarJuego ] = useState(false);

  //Creamos un estado que maneje la renderizacion del componente cajon de preguntas
  const [estadoCajonPreguntas, setEstadoCajonPreguntas] = useState(false);

  //Creamos un estado que guarde el index del ficho actual
  const [indexActual, setIndexActual] = useState("");

  //Establecemos un estado con la casilla anterior
  const [ casillaAnterior, setCasillaAnterior ] = useState(0);

  //Establecemos un estado con la casilla actual
  const [ casillaActual, setCasillaActual] = useState(0);

  //Creamos un estado que manejara las alertas.
  const [ estadoAlerta, setEstadoAlerta ] = useState(false);

  const [ estadoAlertaPerderTurno, setEstadoAlertaPerderTurno ] = useState(false);

  //Creamos un estado que manejara el mensaje de las alertas.
  const [ mensajeAlerta, setMensajeAlerta ] = useState("vacio");
  const [ mensajeAlertaPerderTurno, setMensajeAlertaPerderTurno ] = useState("vacio");

  //Creamos un estado para renderizar si se aciertan o se fallan las respuestas
  const [ estadoRespuesta, setEstadoRespuesta ] = useState(false);

  //Creamos un estado que recibira si el usuario respondio bien o mal para determinar que se mostrara en pantalla.
  const [ tipoRespuesta, setTipoRespuesta ] = useState(false);

  //Establecemos cuatro estados que conservaran las posiciones actuales de cada ficho
  const [ fichoAzul, setFichoAzul ] = useState("casilla1");
  const [ fichoRojo, setFichoRojo ] = useState("casilla1");
  const [ fichoVerde, setFichoVerde ] = useState("casilla1");
  const [ fichoRosa, setFichoRosa ] = useState("casilla1");

  //Creamos un estado que se activara cuando el juego termine y mostrara los resultados.
  const [ finalJuego, setFinalJuego ] = useState(false);

  //Creamos un estado que maneje la pantalla de inicio
  const [ pantallaInicialEstado, setPantallaInicialEstado ] = useState(true);

  //Creamos un estado que maneje el tipo de pregunta en la que cae el usuario
  const [ tipoPregunta, setTipoPregunta ] = useState(null);

  //Creamos un estado que mostrara una pista cuando un ficho caiga en una casilla de pista.
  const [ casillaPista, setCasillaPista ] = useState(false);

  //Creamos un estado que se cambiara cuando el o los jugadores completen el registro.
  const [ pantallaDeRegistro, setPantallaDeRegistro ] = useState(false);

  //Creamos un estado para el bloqueador del dado mientras se este saltando turno
  const [ bloqueoSaltarTurno, setBloqueSaltarturno ] = useState(false);

  //Creamos un estado que toma el tema elegido por los jugadores
  const [ temaElegido, setTemaElegido ] = useState();

  //Desarrollar las notificaciones despues de cerrar la pista, le decimos a un use effect que sejecute cuando cambie el estado de casillap pista y este sea falso--- para cuando cerremos la pista se ejecuten las notificaciones correspondientes.

  const pantallaDeRegistroActivacion = (boolean) => {
    setPantallaDeRegistro(boolean);
  }

  //Creamos un estado que manejara los datos que se reciban del formulario
  const [ datosJugadores, setDatosJugadores ] = useState([]);

  //Estado creado para subir los datos antes de que se muestre la pantalla final
  const [completadoSubirDatos, setCompletadoSubirDatos] = useState(false);

  //Estados que recibe el tiempo de las preguntas y pistas
  const [ temporizadorPreguntas, setTemporizadorPreguntas ] = useState(15);
  const [ temporizadorPistas, setTemporizadorPistas ] = useState(10);

  //Estado que controla la apertura y cierre del panel de instrucciones.
  const [ mostrarInstrucciones , setMostrarInstrucciones ] = useState(false);

  //Estado para controlar el color del dado cuando se salte turno
  const [ saltarTurnoDado, setSaltarTurnoDado ] = useState(false);

  //Mostrar alerta de casilla 1
  const [ casillaUnoActivacion, setCasillaUnoActivacion ] = useState(null);


  //________________________________________________________________________________________

  //Mostrar instrucciones despues de un tiempo para no solapar las pantallas
  useEffect(() => {
    setTimeout(() => {
      setPantallaDeRegistro(true);
    }, 3000);
  }, []);

  //Ejecutamos una pantalla inicial que muestra el titulo del juego y los desarrolladores.
  pantallaInicioFuncionamiento(setPantallaInicialEstado);


  //Creamos una funcion que nos traera el valor del componente en este caso el resultado del dado y esta funcion la llevamos como props al componente, despues de traer el resultado lo pasamos a un estado creado previamente en este caso llamado (valorDado);
  const traerValorDado = (valor, tirada) => {
    setValorDado(valor);
    setTiradaDado(tirada);
  }
  //console.log("ValorDado:", valorDado);


  //Creamos un ciclo for que generara los 50 componentes casilla que necesitamos automaticamente y le dara un el numero correspondiente en el droppableId y en casilla que corresponde a los estilos.
  let arrayCasillas = [];
  for (let i = 1; i < 51; i++) {
    arrayCasillas.push(<Casilla casilla={`casillas__casilla casillas__casilla--${i}`} droppableId={`casilla${i}`} listaFichos={casillasEstado}/>)
  }

  //Creamos una funcion que conectada al componente boton nos traera un boleano si se le da click al boton cambiando el componente de boton a el contador en pantalla.
  const botonIniciarJuego = (boleano) => {
    setEstadoIniciarJuego(boleano);
    setValorDado(-100);
    //Establecemos una alerta para mostrar el primer turno en este caso el azul, determinamos si se dio click en el boton se ejecuta la funcion y el boleano sera true en este caso seteamos el estado del mensaje y el estado de la alerta para mostrar y despues de 3 segundos se setea en false y se quita la alerta.
    if(boleano === true){
      setMensajeAlerta("Turno de Ficho azul")
      setEstadoAlerta(true);
      setTimeout(() => setEstadoAlerta(false), 3000);
    }
  }

  //Preguntas
  //Creamos una funcion que traera del componente de cajon de preguntas si ya se respondio para desaparecer ese componente.
  const validarTiempoDeEjecucionCajonPreguntas = (boleano, respuesta) => {
    setEstadoCajonPreguntas(boleano);

    //
    asignacionPreguntasAcumulacion(puntuacion, setPuntuacion, turnoActual);

    //Seteamos si el usuario respondio bien o mal para saber que componente mostrar en pantalla
    setTipoRespuesta(respuesta);

    //Establecemos el estado de respuesta para que este muestre si la respuesta fue buena o mala y ademas aplicamos un setTimeout que hara que el estado se quite y deje de mostrar el mensaje.
    setEstadoRespuesta(true);
    setTimeout(() => setEstadoRespuesta(false) , 3000);


    //Determinamos un if que pregunte a la funcion corroborarCasillaPregunta que tipo de pregunta es, si es de tobogan, escalera o pregunta de turno extra y dependiendo el tipo de pregunta y la respuesta de la misma se ejecutara el codigo dentro de cada fragmento.
    if(respuesta === true && corroborarCasillaPregunta(casillaActual) === "casillaEscalera"){
      //Cambiamos el codigo y establecemos que si el jugador acerto la pregunta este suba por la escalera
      setTimeout(() => subirEscalera( casillasEstado, casillaActual)
            ,1000 );
      //Añadimos un set time out que mostrara el turno del siguiente ficho despues de mostrar la pantalla de ,
      setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual-1, estadoIniciarJuego), 0, 3000), 3900);



    }else if( respuesta === true && corroborarCasillaPregunta(casillaActual) === "casillaExtra"){
      turnoExtra(turnoActual, setTurnoActual, setEstadoAlerta, setMensajeAlerta, puntuacion, setPuntuacion);

      if(turnoActual === 1){
        setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(3, estadoIniciarJuego), 0), 3900);
      }else{
        setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual-2, estadoIniciarJuego), 0, 3000), 3900);
      }

    }else if( respuesta === true && corroborarCasillaPregunta(casillaActual) === "casillaTobogan"){
      asignacionPuntos( puntuacion, setPuntuacion, turnoActual, 1 );
      console.log("CorroborarCasillaPregunta", corroborarCasillaPregunta(casillaActual))
      //Añadimos un set time out que mostrara el turno del siguiente ficho despues de mostrar la pantalla de ,
      setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, "Te mantienes en la casilla actual.", 0, 2000), 1000);
      setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual-1, estadoIniciarJuego), 0, 3000), 3900);

    }else if(respuesta === false && corroborarCasillaPregunta(casillaActual) === "casillaTobogan"){
      //Si el jugador fallo en la pregunta y estamos en casilla de tobogan el jugador caera en el tobogan.
      setTimeout(() => bajarTobogan( casillasEstado, casillaActual)
      ,1000 );
      //Añadimos un set time out que mostrara el turno del siguiente ficho despues de mostrar la pantalla de ,
      setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual-1, estadoIniciarJuego), 0, 3000), 3900);
    }else{
      setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual-1, estadoIniciarJuego), 0, 3000), 3900);
    }
  }




  useEffect(() => {
    if(casillaPista === false && estadoIniciarJuego === true){
      setTimeout(() => manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual-1, estadoIniciarJuego), 0, 3000), 500);
    }
  }, [casillaPista])




  //Creamos una funcion que valide la casilla en la que se esta y que cuando se caiga en casilla de pregunta active el componente de pregunta.



  const validarCasillasDePregunta = (casilla) => {
    switch(casilla) {
      case "casilla3":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla5":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasEscalera");
        break;
      case "casilla11":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasEscalera");
        break;
      case "casilla15":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla18":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTobogan");
        break;
      case "casilla21":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla23":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasEscalera");
        break;
      case "casilla25":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTobogan");
        break;
      case "casilla27":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasEscalera");
        break;
      case "casilla29":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla30":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasEscalera");
        break;
      case "casilla31":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTobogan");
        break;
      case "casilla34":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla36":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla37":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasEscalera");
        break;
      case "casilla39":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTobogan");
        break;
      case "casilla41":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla45":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla46":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTobogan");
        break;
      case "casilla48":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTurnoEXtra");
        break;
      case "casilla49":
        setEstadoCajonPreguntas(true);
        setTipoPregunta("preguntasTobogan");
        break;
      default:
        // code block
    }
  }


  //Creamos una funcion que se ejecutara y hara que se salte el turno actual del jugador que no tire el numero exacto y mas abajo creamos varios if que validaran cada turno y confirmaran si se cumplen los requisitos que pidela funcion para saltar el turno.

  //Dentro de la funcion creamos un if que en caso de que ese ficho este en la casilla 50 se ejecutara ese fragmento de codigo pero ademas se ejecutara el resto del codigo dando las alertas necesarias, y saltando el turno correctamente para dar paso al otro ficho que sigue a continuacion.

  const saltarTurno = (ficho, fichoSiguiente) => {
    setBloqueSaltarturno(true);

    if(ficho === "casilla50"){
      setTurnoActual(validarTurno(turnoActual));
      setTiradaDado(false);
      }

    console.log(fichoSiguiente, "ficho siguiente");

    if(fichoSiguiente !== "casilla50"){
      setTimeout(() => {
        manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), 3250, 3000);
        setBloqueSaltarturno(false);
      }, 4000);
    }

      setTimeout(() => {
        manejoAlertasPerderTurno(setEstadoAlertaPerderTurno, setMensajeAlertaPerderTurno, "Saltando turno", 3250, 1800);
      }, 1000);


      // if(fichoSiguiente === "casilla50"){
      //   setTimeout(() => {
      //     manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), 3250, 3000);
      //   }, 4000);
      // }

      setTurnoActual(validarTurno(turnoActual));
      setValorDado(-100);
      setTiradaDado(false);
    }


//En esta seccion de codigo definimos una funcion que compruebe si los cuatro fichos estan en la casilla 50 y en caso tal muestre la pantalla de finalizacion de juego, en el caso de que no se cumpla esa parte del codigo, pasara a otro fragmento que comprobara si hay algun ficho en la casilla 50 y en ese caso se saltara el turno y sacara las notificaciones pertinentes. NOTA para evitar que se renderizara y sacara error el codigo se implementa un use efect que se ejecuta al cmabio de los estados seleccionados en el y que evita que salga un error al mostrar la ultima pantalla.
useEffect(() => {
  funcionFinal();
}, [estadoAlerta, estadoAlertaPerderTurno, estadoRespuesta, casillasEstado, valorDado]);

const funcionFinal = ()  => {

  if( fichoAzul === "casilla50" && fichoRojo === "casilla50" && fichoVerde === "casilla50" && fichoRosa === "casilla50" ){
    // console.log("Juego Terminado...");
    traerValorTemporizador(true);
  }else{
    if( turnoActual === 1){
      // console.log("Validacion", estadoCajonPreguntas)
      // console.log("validar llegada", validarLlegada( fichoAzul, valorDado ))
      if( validarLlegada( fichoAzul, valorDado ) === true && estadoCajonPreguntas === false){
        // console.log("Ejecutando saltar turno");
        saltarTurno(fichoAzul, fichoRojo);
        cambioTurnoControlEstados(setSaltarTurnoDado);
      }
    }else if( turnoActual === 2){
      // console.log("Validacion", estadoCajonPreguntas)
      // console.log("validar llegada", validarLlegada( fichoRojo, valorDado ))
      if( validarLlegada( fichoRojo, valorDado ) === true && estadoCajonPreguntas === false){
        saltarTurno(fichoRojo,  fichoVerde);
        cambioTurnoControlEstados(setSaltarTurnoDado);
        // console.log("Ejecutando saltar turno");
      }
    }else if( turnoActual === 3){
      // console.log("Validacion", estadoCajonPreguntas)
      // console.log("validar llegada", validarLlegada( fichoVerde, valorDado ))
      if( validarLlegada( fichoVerde, valorDado ) === true && estadoCajonPreguntas === false){
        saltarTurno(fichoVerde, fichoRosa);
        cambioTurnoControlEstados(setSaltarTurnoDado);
        console.log("Ejecutando saltar turno");
      }
    }else if( turnoActual === 4){
      // console.log("Validacion", estadoCajonPreguntas)
      // console.log("validar llegada", validarLlegada( fichoRosa, valorDado ))
      if( validarLlegada( fichoRosa, valorDado ) === true && estadoCajonPreguntas === false){
        saltarTurno(fichoRosa, fichoAzul);
        cambioTurnoControlEstados(setSaltarTurnoDado);
        console.log("Ejecutando saltar turno");
      }
    }
  }
}


//________________________________________________________________________________________________________

  //Codigo en desuso(Este codigo hacia que el ficho del jugador se devolviera a la casilla anterior cuando fallaba la pregunta.)

  //Funcion para establecer cuando se falla las preguntas que el ficho se devuelva a la casilla correspondiente.

  // const falloPregunta = (lista) => {
  //   let result = lista;

  //   const [removed] = result[casillaActual].splice(indexActual, 1);
  //   result[casillaAnterior].splice(5, 0, removed);
  //   setCasillasEstado(result);

  //   //En caso de que el jugador actual falle la pregunta guardaremos la casilla a la que fue devuelto sobreescribiendo la casilla que se seteo cuando se movio el ficho.
  //   establecerPosicionFichos(turnoActual - 1, casillaAnterior, setFichoAzul, setFichoRojo,setFichoVerde, setFichoRosa);
  // }

  //____________________________________________________________________________________________________



  //Creamos una funcion que se activa cuando el jugador cae en la casilla correspondiente y avanza a la casilla que este conectada con la casilla actual.
  const subirEscalera = (lista, casillaActual) => {

    let result = lista;

    asignacionPuntos( puntuacion, setPuntuacion, turnoActual, 1 );

    manejoAlertas(setEstadoAlerta, setMensajeAlerta, "Avanzas con la escalera!", 3000 ,2300);


    const [removed] = result[casillaActual].splice(0, 1);
    console.log("Removed",removed);
    result[casillaDestinoEscalera(casillaActual)].splice(5, 0, removed);
    setCasillasEstado(result);

    establecerPosicionFichos(turnoActual - 1, casillaDestinoEscalera(casillaActual), setFichoAzul, setFichoRojo,setFichoVerde, setFichoRosa);
  }



  //Creamos una funcion que se activa cuando el jugador cae en la casilla correspondiente y avanza a la casilla que este conectada con la casilla actual.
  const bajarTobogan = (lista, casillaActual) => {
    let result = lista;

    manejoAlertas(setEstadoAlerta, setMensajeAlerta, "Ups caes en el tobogan", 3000, 2300);

    const [removed] = result[casillaActual].splice(0, 1);
    result[casillaDestinoTobogan(casillaActual)].splice(5, 0, removed);
    setCasillasEstado(result);

    establecerPosicionFichos(turnoActual - 1, casillaDestinoTobogan(casillaActual), setFichoAzul, setFichoRojo,setFichoVerde, setFichoRosa);
  }


  //Creamos una funcion que traiga del componente temporizador si el tiempo de juego se acabo y active el componente del final del juego.
  const traerValorTemporizador = (valor) => {
    setCompletadoSubirDatos(true);
    setTimeout(() => {
      setFinalJuego(valor);
      //setCompletadoSubirDatos(false);
    }, 5000);
  }


  //Creamos una funcion que ocultara las pistas despues de que el tiempo determinado a pasado.
  const funcionTemporizadorPistas = () => {
    setCasillaPista(false);
  }


  //Seccion para subir los datos a la DB
  const recogerDatosComponenteFormulario = (datos) => {
    setDatosJugadores(datos);
  }

  const fetchPostDB = async (datosJugadores,puntuacion) => {
    console.log("DatosJugadores",datosJugadores);
    console.log("Puntuacion",puntuacion);

    for(let i = 0;i < 4; i++){
        let config = {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json'
            },body: JSON.stringify({
                _id: datosJugadores[i]._id,
                sesion: datosJugadores[i].sesion,
                nombre: datosJugadores[i].nombre,
                email: datosJugadores[i].email,
                preguntas: puntuacion[i].preguntas,
                puntuacion: puntuacion[i].puntuacion
            })
        }
        let res = await fetch('https://backend-escalera-udea.onrender.com/api/estudiantes',config)
        let json = await res.json()

        console.log(json)
    }

}

  //ejecutamos un if que compruebe si se acabo el juego para subir los datos a la DB
  useEffect(() => {
      if(completadoSubirDatos === true){
      fetchPostDB(datosJugadores, puntuacion);
    }
  }, [completadoSubirDatos]);




  //recibimos los datos de los temporizadores
  const datosTemporizadores = (preguntas, pistas) => {
    setTemporizadorPreguntas(preguntas);
    setTemporizadorPistas(pistas);
  }


  //Funcion que al darle click al boton de instrucciones se muestren las intrucciones.
  const mostrarInstruccionesFuncion = (boolean) => {
    setMostrarInstrucciones(boolean);
  }


  //Funcion para reiniciar la partida.
  const reiniciarPartida = () => {
    let result = casillasEstado;
    //Definimos el valor del dado para no tener errores a la posicion inicial de su valor
    setValorDado(150);
    //Reiniciamos las puntuaciones a cero.
    if(reinicios === 0){
      setPuntuacion(puntuacionesRespaldo2);
      reinicios = reinicios + 1;
    }else if(reinicios === 1){
      setPuntuacion(puntuacionesRespaldo3);
      reinicios = reinicios + 1;
    }else if(reinicios === 2){
      setPuntuacion(puntuacionesRespaldo4);
      reinicios = reinicios + 1;
    }else if(reinicios === 3){
      setPuntuacion(puntuacionesRespaldo5);
      reinicios = reinicios + 1;
    }else if(reinicios === 4){
      setPuntuacion(puntuacionesRespaldo6);
      reinicios = reinicios + 1;
    }

    //Reestablecemos el turno actual a 1
    setTurnoActual(1);
    //Definimos el juego a que no a iniciado
    setEstadoIniciarJuego(false);
    //reestablecemos el estado de la casilla actual
    setCasillaActual(0);
    //Reiniciamos las posiciiones de los fichos
    const [removedAzul] = result[fichoAzul].splice(0, 1);
    result["casilla1"].splice(5,0, removedAzul);
    const [removedRojo] = result[fichoRojo].splice(0, 1);
    result["casilla1"].splice(5,0, removedRojo);
    const [removedVerde] = result[fichoVerde].splice(0, 1);
    result["casilla1"].splice(5,0, removedVerde);
    const [removedRosa] = result[fichoRosa].splice(0, 1);
    result["casilla1"].splice(5,0, removedRosa);
    //Devolvemos los fichos a la casilla 1 en el estado que vigila
    setFichoAzul("casilla1");
    setFichoRojo("casilla1");
    setFichoVerde("casilla1");
    setFichoRosa("casilla1");
    //Reestablecemos el estado del final del juego
    setFinalJuego(false);
    //reiniciamos la pantalla de registro
    setPantallaDeRegistro(false);
    //Estado que reestablece la pantalla de partida finalizada
    setCompletadoSubirDatos(false);
  }

  //Generamos una funcion para activar el letrero de la casilla 1 que ejecutara el boton final del registro.
  const mostrarLetreroCasillaUno = () => {
    setTimeout(() => {
      setCasillaUnoActivacion(true);
    }, 1000);
  };


  // console.log("Tema elegido", temaElegido);

  //Creamos varios setTimeOut que activaran el servidor para cuando se suban los datos no se pierdan los primeros datos.

  useEffect(() => {
    setTimeout(() => {
      fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
      .then(response => response.json())
      console.log("Activando el servidor timer 1")
    }, 100000);
  
    setTimeout(() => {
      fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
      .then(response => response.json())
      console.log("Activando el servidor timer 2")
    }, 200000);
  
    setTimeout(() => {
      fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
      .then(response => response.json())
    }, 300000);
  
    setTimeout(() => {
      fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
      .then(response => response.json())
    }, 400000);
  
    setTimeout(() => {
      fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
      .then(response => response.json())
    }, 500000);
  
  }, [])

  return (
    <div className="App">
      {/*Casillas invisibles de interaccion*/}
      <DragDropContext
              onDragEnd={(result) => {
        // console.log("Estado del turno:",turnoActual);
        // console.log("result:",result);
        //console.log("result.destination.droppableId",result.destination.droppableId);
        // console.log("source.index:", result.source.droppableId.slice(7));
        // console.log("source.destination:", result.destination.droppableId.slice(7));
        const { source, destination, draggableId } = result;

        //let operacionCasillasMovimiento = destination.droppableId.slice(7) - source.droppableId.slice(7);


        //console.log("operacionCasillasMovimiento",operacionCasillasMovimiento);


        if (!destination) {
          return;
        }
        if (
          source.index === destination.index &&
          source.droppableId === destination.droppableId
        ) {
          return;
        }



        //Creamos un if que valide si las casillas que se mueve el ficho corresponden al valor del dado asi si el usuario mueve el ficho hacia otra casilla este se devuelve a la casilla original
        let operacionCasillasMovimiento;
        if(destination.droppableId != null){
        //Creamos una variable que operara el punto de partida del ficho con el punto de destino y asi calculara si coincide con el resultado de el dado.
          operacionCasillasMovimiento = destination.droppableId.slice(7) - source.droppableId.slice(7);

          if(valorDado === operacionCasillasMovimiento && draggableId == turnoActual){
            //Establecemos el estado con el turno y su funcion correspondiente.
            setTurnoActual(validarTurno(turnoActual));
            //console.log("Estado del turno:",turnoActual);







            //Establecemos al terminar el turno condicionales que evaluan si el ficho que sigue esta en la casilla 50 para no sacar la notificacion de ese turno en pantalla sino que aparezca el turno del jugador que sigue despues, ademas esos condicionales lo metemos dentro de otro que verifica si la casilla es de escalera para subir o tobogan para bajar y evita la notificacion para que esta este configurada para salir cuando termine toda la interaccion.ademas creamos un else que se ejecuta cuando el jugador cae en una ficha de escalera y asi avanza a la casilla pertinente sacando la notificacion del ficho que sigue.

            if( saltarNotificacionesCasilasEscalera(destination.droppableId) === false && saltarNotificacionesCasilasTobogan(destination.droppableId) === false ){
              // console.log("Ejectando notificacion 1")

              if( turnoActual === 1 ){
                if( fichoRojo !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
              }else if(turnoActual === 2){
                if( fichoVerde !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
              }else if( turnoActual === 3){
                if( fichoRosa !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
              }else if( turnoActual === 4 ){
                if( fichoAzul !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
            }
            }else if( saltarNotificacionesCasilasEscalera(destination.droppableId) === true && saltarNotificacionesCasilasTobogan(destination.droppableId) === true ){
              console.log("Ejecutando notificacion 2");
              //manejoAlertas(setEstadoAlerta, setMensajeAlerta, "Avanzas con la escalera!", 3250);
            //     setTimeout(() => subirEscalera( casillasEstado, destination.droppableId )
            // ,1000 );

            setTimeout(() => {
              if( turnoActual === 1 ){
                if( fichoRojo !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
              }else if(turnoActual === 2){
                if( fichoVerde !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
              }else if( turnoActual === 3){
                if( fichoRosa !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
              }else if( turnoActual === 4 ){
                if( fichoAzul !== "casilla50" ){
                  manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)), 3000);
                }
            }}, 1500);}





            // }else if(saltarNotificacionesCasilasTobogan(destination.droppableId) === true ){
            //   manejoAlertas(setEstadoAlerta, setMensajeAlerta, "Ups caes en el tobogan!", 3250);
            //     setTimeout(() => bajarTobogan( casillasEstado, destination.droppableId )
            // ,1000 );

            // setTimeout(() => {
            //   if( turnoActual === 1 ){
            //     if( fichoRojo !== "casilla50" ){
            //       manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)));
            //     }
            //   }else if(turnoActual === 2){
            //     if( fichoVerde !== "casilla50" ){
            //       manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)));
            //     }
            //   }else if( turnoActual === 3){
            //     if( fichoRosa !== "casilla50" ){
            //       manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)));
            //     }
            //   }else if( turnoActual === 4 ){
            //     if( fichoAzul !== "casilla50" ){
            //       manejoAlertas(setEstadoAlerta, setMensajeAlerta, letreroTurno(turnoActual, estadoIniciarJuego), parseInt(destination.droppableId.slice(7)));
            //     }
            // }}, 1500);
            // }




            //Despues de mover a la casilla correspondiente el ficho que se puede mover pasar pasaremos -100 el valor del dado para que el otro jugador tenga que tirar y no mueva el ficho siguiente a la casilla del anterior sin tirar del dado, como el tablero solo tiene 50 casillas lo maximo que se puede retroceder es 49 casillas asi con el -100 evitamos que se mueva el ficho a otra casilla sin tirar antes del dado.
            setValorDado(-100);


            //Ejecutamos la funcion que verifica en que casilla si la casilla actual es de pregunta.
            validarCasillasDePregunta(destination.droppableId);
            //Funcion que verifica si es casilla pista y ejecuta el respectivo proceso de las pistas.
            validarCasillasPista(destination.droppableId, setCasillaPista);

            //Guardamos la ubicacion actual de cada ficho.
            establecerPosicionFichos(turnoActual, destination.droppableId, setFichoAzul, setFichoRojo,setFichoVerde, setFichoRosa);



            //Establecemosla tirada del dado en falso para el siguiente turno
            setTiradaDado(false);


            setCasillaAnterior(source.droppableId);
            setCasillaActual(destination.droppableId);
            setIndexActual(destination.index);

            setCasillasEstado((prevTasks) =>
            reorder(prevTasks, source.index, destination.index, source.droppableId, destination.droppableId));
        }}
      }}
      >
        <div>
          {arrayCasillas}
        </div>
      </DragDropContext>

      <div className="sidebar__div--container">
        {/*Dado*/}
        <Dado fValorDado={traerValorDado} turnoActual={turnoActual} validarTirada={valorDado} botonIniciarJuego={estadoIniciarJuego} setEstadoAlerta={setEstadoAlerta} setMensajeAlerta={setMensajeAlerta} saltarTurnoDado={saltarTurnoDado}/>

        {/*Boton/cuenta regresiva: tenemos un estado que se acciona y muestra la cuenta regresiva posterior a darle click al boton*/}
        {estadoIniciarJuego ? (<Countdown valorTemporizador={traerValorTemporizador}/>):(<BotonIniciarJuego funcionIniciarJuego={botonIniciarJuego} texto="iniciar" />)}

      </div>

      {/*Componente que se renderiza cada vez que se cae en una casilla de preguntas*/}
      {estadoCajonPreguntas ? (<CajonPreguntas temaElegido={temaElegido} temporizadorPreguntas={temporizadorPreguntas} tipoPreguntas={tipoPregunta} fRenderizacionComponente={validarTiempoDeEjecucionCajonPreguntas}/>):("")}

      {/*Componente de alertas que se ejecutara para indicarle al jugador informacion relevante.*/}
      {estadoAlerta ? (<Alertas mensaje={mensajeAlerta}/>):("")}
      {estadoAlertaPerderTurno ? (<Alertas2 mensaje={mensajeAlertaPerderTurno}/>):("")}

      {/*Componente de respuesta que renderiza si la respuesta del usuario fue correcta o fallo*/}
      {estadoRespuesta ? (<Respuesta tipoRespuesta={tipoRespuesta}/>):("")}
      {/* <Respuesta tipoRespuesta={tipoRespuesta}/> */}

      {/*Componente que muestra los resultados finales de la partida*/}
      {finalJuego ? (<PantallaFinal puntuaciones={puntuacion} finalJuego={finalJuego} reiniciarPartida={reiniciarPartida}/>):("")}

      {/*Componente que muestra la pantalla inicial el juego*/}
      {pantallaInicialEstado ? (<PantallaInicio/>):("")}

      {/*Componente que muestra las pistas*/}
      {casillaPista ? (<Pistas temaElegido={temaElegido} temporizadorPistas={temporizadorPistas} fTemporizadorPistas={funcionTemporizadorPistas}/>):("")}

      {/*Componente que contiene las puntuaciones de los jugadores.*/}
      {estadoIniciarJuego ? (<PanelDePuntuaciones puntuaciones={puntuacion}/>):("")}

      {/* Componente pantalla de formulario de inicio */}
      {pantallaDeRegistro ? (<Formulario datosTemporizadores={datosTemporizadores} puntuacion={puntuacion} activarPantallaRegistro={pantallaDeRegistroActivacion}  finalJuego={finalJuego} datosJugadores={recogerDatosComponenteFormulario} mostrarLetreroCasillaUno={mostrarLetreroCasillaUno} setTemaElegido={setTemaElegido}/>):("")}

      {/*Pantalla de partida finalizada*/}
      {completadoSubirDatos ? (<PartidaFinalizada/>):("")}


      {/*Imagenes interactivas del juego*/}
      <EscaleraInteractiva imagen={asset9} alt="asset13" top="12.8vw" left="20vw" width="14vw"/>
      <EscaleraInteractiva imagen={asset1} alt="asset1" top="8.7vw" left="58.5vw" width="5.3vw"/>
      <EscaleraInteractiva imagen={asset2} alt="asset2" top="16vw" left="25vw" width="3.3vw"/>
      <EscaleraInteractiva imagen={asset3} alt="asset3" top="6vw" left="78vw" width="8vw"/>
      <EscaleraInteractiva imagen={asset4} alt="asset4" top="24.8vw" left="21.3vw" width="8vw"/>
      <EscaleraInteractiva imagen={asset5} alt="asset5" top="31.5vw" left="15.2vw" width="3.5vw"/>
      <EscaleraInteractiva imagen={asset4} alt="asset6" top="28vw" left="65.5vw" width="9vw"/>
      <EscaleraInteractiva imagen={asset2} alt="asset7" top="33vw" left="35vw" width="3vw"/>
      <EscaleraInteractiva imagen={asset6} alt="asset8" top="33vw" left="60.8vw" width="4vw"/>
      <EscaleraInteractiva imagen={asset6} alt="asset9" top="26vw" left="53vw" width="3.8vw"/>
      <EscaleraInteractiva imagen={asset7} alt="asset10" top="16vw" left="43vw" width="7vw"/>
      <EscaleraInteractiva imagen={asset8} alt="asset11" top="13vw" left="58.5vw" width="14vw"/>
      <EscaleraInteractiva imagen={asset7} alt="asset12" top="7.8vw" left="26vw" width="7vw"/>


      {/*Logo animado*/}
      <LogoAnimado/>

      {/*Logos UDEA*/}
      <LogosUDEA componente='juego'/>

      {/*Logos Gobierno*/}
      <LogoGobierno/>

      {/*Boton instrucciones*/}
      <button className='app__button--instrucciones' onClick={() => mostrarInstruccionesFuncion(true)}></button>

      {/*Panel de instrucciones*/}
      {mostrarInstrucciones ? (<Instrucciones mostrarInstruccionesFuncion={mostrarInstruccionesFuncion}/>):("")}

      {/*Se crea un div transparente que bloquea el dado cada vez que sale una notificacion de saltar turno*/}
      {bloqueoSaltarTurno ? (<div className='app__div--bloqueo-saltar-turno'></div>):("")}

      {/*Creamos la notificacion de que se comienza en la casilla 1*/}
      {casillaUnoActivacion ? (<AlertaDeCasillaUno setCasillaUnoActivacion={setCasillaUnoActivacion}/>):("")}
    </div>
  );
}

export default App;
